import { createComponent } from '@carvana/merch-components';
import {
  Card,
  DetailsContentWrapper,
  DetailsWrapper,
  TitleWrapper,
  YMMTMWrapper
} from './StatusCard.styles';

const LoadingBlock = createComponent('div', {
  className: 'animate-pulse rounded-[6px] bg-background-skeleton'
});

export default function LoadingCard() {
  return (
    <Card className="l:col-span-2">
      <TitleWrapper>
        <LoadingBlock className="h-20 w-1/2 m:h-24" />
        <LoadingBlock className="h-48 w-full m:h-28 m:w-3/4" />
      </TitleWrapper>
      <DetailsWrapper>
        <DetailsContentWrapper className="w-full m:w-[291px]">
          <YMMTMWrapper>
            <LoadingBlock className="h-20 w-1/2 m:h-24 m:w-3/4" />
            <LoadingBlock className="h-20  w-3/4 m:h-24 m:w-full" />
          </YMMTMWrapper>
          <LoadingBlock className="h-56 w-full" />
        </DetailsContentWrapper>
        <LoadingBlock className=" aspect-video w-full flex-grow m:aspect-[4/3] m:h-[258px] m:max-w-[344px]" />
      </DetailsWrapper>
    </Card>
  );
}
